var map = {
	"./Fighter_lvl3.json": 90,
	"./Gnome Ranger_lvl3.json": 91,
	"./Half-elf Monk_lvl3_19_07_2022.json": 92,
	"./High-elf wizard_lvl3_19_07_2022.json": 93,
	"./Human Druid_lvl3_19_07_2022.json": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 178;